import api from './api';
import { API_ENDPOINTS, buildApiUrl, buildApiUrlWithQuery } from '../config/api';
import { normalizeCategory, normalizeProduct } from '../utils/media';

export const productService = {
  // Get all products with optional filters
  getAllProducts: async (filters = {}) => {
    try {
      const url = buildApiUrlWithQuery(API_ENDPOINTS.PRODUCTS.LIST, filters);
      const response = await api.get(url);
      const hasResults = Array.isArray(response.data?.results);
      const productsPayload = hasResults
        ? response.data.results
        : Array.isArray(response.data)
          ? response.data
          : [];
      const normalizedProducts = productsPayload.map(normalizeProduct);
      return normalizedProducts;
    } catch (error) {
      console.error('Error fetching products:', error);
      throw error;
    }
  },

  // Get single product by ID
  getProductById: async (id) => {
    try {
      const url = buildApiUrl(`${API_ENDPOINTS.PRODUCTS.DETAIL}/${id}/`);
      const response = await api.get(url);
      return normalizeProduct(response.data);
    } catch (error) {
      console.error('Error fetching product:', error);
      throw error;
    }
  },

  // Get products by category
  getProductsByCategory: async (category) => {
    try {
      const url = buildApiUrlWithQuery(API_ENDPOINTS.PRODUCTS.LIST, { category });
      const response = await api.get(url);
      const hasResults = Array.isArray(response.data?.results);
      const productsPayload = hasResults
        ? response.data.results
        : Array.isArray(response.data)
          ? response.data
          : [];
      const normalizedProducts = productsPayload.map(normalizeProduct);
      return normalizedProducts;
    } catch (error) {
      console.error('Error fetching products by category:', error);
      throw error;
    }
  },

  // Search products
  searchProducts: async (query) => {
    try {
      const url = buildApiUrlWithQuery(API_ENDPOINTS.PRODUCTS.LIST, { search: query });
      const response = await api.get(url);
      const hasResults = Array.isArray(response.data?.results);
      const productsPayload = hasResults
        ? response.data.results
        : Array.isArray(response.data)
          ? response.data
          : [];
      const normalizedProducts = productsPayload.map(normalizeProduct);
      return normalizedProducts;
    } catch (error) {
      console.error('Error searching products:', error);
      throw error;
    }
  },

  // Get product categories
  getCategories: async () => {
    try {
      const url = buildApiUrl(API_ENDPOINTS.CATEGORIES.LIST);
      const response = await api.get(url);
      const hasResults = Array.isArray(response.data?.results);
      const categoriesPayload = hasResults
        ? response.data.results
        : Array.isArray(response.data)
          ? response.data
          : [];
      const normalizedCategories = categoriesPayload.map(normalizeCategory);
      return normalizedCategories;
    } catch (error) {
      console.error('Error fetching categories:', error);
      throw error;
    }
  }
};

export default productService;
